module.exports = __webpack_public_path__ + "static/media/model-patrol-88-lwb.28d36bd9.webp";